const Answers = [
    {
        r1:`Elegí ser Desarrollador Web porque me fascina el hecho
        de poder crear algo que pueda ser utilizado por
        cientos de personas en cuestión de segundos, sabiendo que esas
        personas podrán disfrutar el fruto de tu trabajo. Eso sin mencionar 
        la constante evolución del rubro, todos los días hay algo
        nuevo para comprender.`,
        r1_en:`I chose to be a Web Developer because I am fascinated by the fact
        to be able to create something that can be used by
        hundreds of people in a matter of seconds, knowing that those
        People will be able to enjoy the fruit of your labor. That's not to mention
        the constant evolution of the field, every day there is something
        new to understand.`,
        r1_po:`Escolhi ser Web Developer porque sou fascinado pelo fato de
        ser capaz de criar algo que possa ser usado por
        centenas de pessoas em questão de segundos, sabendo que aqueles
        As pessoas poderão desfrutar do fruto do seu trabalho. Isso sem falar
        a constante evolução do campo, todos os dias há algo
        novo para entender.`

    },
    {
        r2:`Estudié la Orientación de Técnico en Informática en el 
        colegio Monseñor T. Solari, donde realicé mis primeras paginas 
        con HMTL, CSS, y PHP, Así como los fundamentos básicos de la
        programación, posteriormente durante 2021 comencé a capacitarme 
        por mi cuenta en JavaScript, mas precisamente React Y Node Js. hasta que
        a finales de dicho año me inscribí en el Bootcamp SoyHenry, sin embargo,
        decidí dejarlo debido a cuestiones personales.
        ` ,
        r2_en:`I studied the Computer Technician Orientation at the
        Monseñor T. Solari school, where I made my first pages
        with HTML, CSS, and PHP, as well as the basic fundamentals of
        programming, later during 2021 I began to train
        on my own in JavaScript, more precisely React and Node Js. until
        at the end of that year I signed up for the SoyHenry Bootcamp, however,
        I decided to leave it due to personal issues.` ,
        r2_po:`Estudei a Orientação de Técnico em Informática na
        Escola Monsenhor T. Solari, onde fiz minhas primeiras páginas
        com HTML, CSS e PHP, bem como os fundamentos básicos de
        programação, mais tarde durante 2021 comecei a treinar
        por conta própria em JavaScript, mais precisamente React e Node Js. até
        no final daquele ano me inscrevi no SoyHenry Bootcamp, porém,
        Eu decidi deixá-lo devido a problemas pessoais.
        `
    },
    {
        r3:`En cuanto a los Lenguajes de Marcado, domino HTML5, CSS3 y SASS, A su vez, por el lado de la 
        programación con JavaScript, sé utilizar React Js. para el Front-End y Node Js. para
        la parte del Back-End, junto con este último aprendí sobre el uso de Express y Sequelize.
        Finalmente, en cuanto a administración de bases de datos se refiere, sé administrar tanto 
        bases de datos no relacionales (MongoDB), como bases de datos relacionales (MySQL), como dato extra también comprendo
        el lenguaje SQL y el uso de GIT y GITHUB.`,
        r3_en:`Regarding Markup Languages, I am fluent in HTML5, CSS3 and SASS, In turn, on the side of the
        programming with JavaScript, I know how to use React Js. for the Front-End and Node Js. for
        the Back-End part, along with the latter I learned about the use of Express and Sequelize.
        Finally, as far as database administration is concerned, I know how to administer both
        non-relational databases (MongoDB), such as relational databases (MySQL), as extra data I also understand
        the SQL language and the use of GIT and GITHUB.`,
        r3_po:`Com relação às linguagens de marcação, sou fluente em HTML5, CSS3 e SASS, por sua vez, ao lado do
        programando com JavaScript, sei usar React Js. para o Front-End e Node Js. por
        a parte de Back-End, juntamente com esta última aprendi sobre o uso de Express e Sequelize.
        Finalmente, no que diz respeito à administração de banco de dados, eu sei administrar tanto
        bancos de dados não relacionais (MongoDB), como bancos de dados relacionais (MySQL), como dados extras também entendo
        a linguagem SQL e o uso de GIT e GITHUB.`
    },
    {
        r4:`Durante mis inicios me especialicé en diseñar y maquetar distintas plantillas para terceros exclusivamente en 
        HTML y CSS, hasta que a finales de 2021 mientras me capacitaba en React Js. y Node realicé algunos proyectos completos para 
        clientes específicos desarrollados con los frameworks ya mencionados. Me tomé la libertad de presentar algunos de dichos 
        proyectos a continuación. `,
        r4_en:`During my beginnings I specialized in designing and laying out different templates for third parties exclusively in
        HTML and CSS, until the end of 2021 while I was training in React Js. and Node I made some complete projects for
        specific clients developed with the aforementioned frameworks. I took the liberty of presenting some of the sayings
        projects below. `,
        r4_po:`Durante meus primórdios me especializei em desenhar e desenhar diferentes templates para terceiros exclusivamente em
        HTML e CSS, até o final de 2021 enquanto eu estava treinando em React Js. e Node fiz alguns projetos completos para
        clientes específicos desenvolvidos com os frameworks citados. Tomei a liberdade de apresentar alguns dos ditos
        projetos abaixo. `
        
    },
    {
        r5:`Soy de Argentina, por lo que el español es mi lengua materna, y en cuanto al inglés, 
        aunque no lo domino, puedo mantener una conversación a un nivel razonable.`,
        r5_en:`I am from Argentina, so Spanish is my mother tongue, and as for English,
        Although I am not proficient at it, I can hold a conversation at a reasonable level.`,
        r5_po:`Eu sou da Argentina, então o espanhol é minha língua materna, e quanto ao inglês,
        Embora eu não seja proficiente nisso, consigo manter uma conversa em um nível razoável.`
    },
    {
        r6:`Opino que lo más importante y lo primero que tengo en cuenta al momento de 
        desarrollar una página web es la experiencia del usuario, considero indispensable que el usuario
        tenga un buen paso por el sitio web, ya que eso no solo permitirá que vuelva, 
        sino que sea recomendada una y otra vez haciendo crecer la cantidad de visitantes. Eso sin
        menospreciar la buena funcionalidad, sin embargo, considero que una buena página es aquella que
        nos deja con ganas de volver.`,
        r6_en:`I think that the most important thing and the first thing I have in mind when
        developing a web page is the user experience, I consider it essential that the user
        have a good time through the website, as that will not only allow you to come back,
        but that it be recommended over and over again by growing the number of visitors. that without
        underestimate the good functionality, however, I consider that a good page is one that
        leaves us wanting to return.`,
        r6_po:`Acho que o mais importante e a primeira coisa que tenho em mente quando
        desenvolver uma página web é a experiência do usuário, considero essencial que o usuário
        divirta-se no site, pois isso não só permitirá que você volte,
        mas que seja recomendado uma e outra vez aumentando o número de visitantes. isso sem
        subestimar a boa funcionalidade, porém, considero que uma boa página é aquela que
        nos deixa com vontade de voltar.`
    }
    

]

export {Answers};


